// removed by extract-text-webpack-plugin
module.exports = {"Upgrade--content":"Upgrade--content","Upgrade--content--section":"Upgrade--content--section","align-right":"align-right","Panel":"Panel"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/Upgrade/Upgrade.scss
// module id = P1vu
// module chunks = 0